import { createFileRoute } from "@tanstack/react-router";
import Billing from "@/pages/Billing";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dashboard/billing/")({
  head: () => routeHead("/dashboard/billing/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><Billing /></PrivateRoute>
  );
}
